import { render, staticRenderFns } from "./evaluationModal.vue?vue&type=template&id=bb1b7f24&"
import script from "./evaluationModal.vue?vue&type=script&lang=js&"
export * from "./evaluationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports